import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { LANDING_SECTION_IDS } from "src/pages/home/landingStyles";
import {
  isLandingScrollRestoreInProgress,
  peekLandingProductsScrollPosition,
} from "src/pages/home/landingScrollRestore";

export default function ScrollToTop() {
  const location = useLocation();
  const previousPath = useRef({
    pathname: location.pathname,
    hash: location.hash,
  });

  useLayoutEffect(() => {
    const pathChanged =
      previousPath.current.pathname !== location.pathname ||
      previousPath.current.hash !== location.hash;
    previousPath.current = {
      pathname: location.pathname,
      hash: location.hash,
    };

    // Query-only updates (e.g. opening a community post modal) must not
    // jump the dashboard feed back to the top.
    if (!pathChanged) return;

    const scrollTarget =
      typeof location.state?.scrollTo === "string"
        ? location.state.scrollTo
        : location.hash
          ? decodeURIComponent(location.hash.slice(1))
          : null;

    if (location.pathname === "/") {
      if (scrollTarget && LANDING_SECTION_IDS.has(scrollTarget)) {
        return;
      }

      if (
        peekLandingProductsScrollPosition() != null ||
        isLandingScrollRestoreInProgress()
      ) {
        return;
      }

      // Home handles all scroll behavior on the landing page.
      return;
    }

    window.scrollTo(0, 0);
    const main = document.querySelector("[data-testid='main-content']");
    if (main) {
      main.scrollTo(0, 0);
    }
  }, [location.key, location.hash, location.pathname, location.state]);

  return null;
}
